import { ArtifactsModule } from '../modules/artifacts';
import { StartupSubPageShell } from './StartupSubPageShell';

export default function StartupArtifactsPage(): JSX.Element {
  return (
    <StartupSubPageShell activeSection="artifacts">
      {({ startupId }) => <ArtifactsModule owner={{ type: 'startup', startupId }} />}
    </StartupSubPageShell>
  );
}
